import { useTranslation } from 'react-i18next';

import { DataStatus } from '@shared/components/DataStatus/DataStatus.tsx';
import { Item } from '@shared/components/Review/Item/Item.tsx';
import { PossibleStatusDataVariant } from '@shared/components/StatusIcon/StatusIcon.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface VideoStatusProps {
  status: PossibleStatusDataVariant;
}

export function VideoStatus({ status }: VideoStatusProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);
  const statusTranslationKey = status.toLowerCase();

  return (
    <Item label={t('builder.formFields.videoStatus.label')}>
      <DataStatus variant={status} textLabel={t(`dataStatus.${statusTranslationKey}`, { ns: i18nNameSpace.COMMON })} />
    </Item>
  );
}
